import { CanAccess } from "ra-core";
import type { ReactNode } from "react";

/**
 * Administrator-only page gate. `marketing_metrics` list is the CRM's
 * analytics administrator permission (providers/commons/canAccess.ts); the
 * dashboard proxy and API enforce the same boundary server-side.
 */
export const adminOnly = (page: ReactNode) => (
  <CanAccess resource="marketing_metrics" action="list">
    {page}
  </CanAccess>
);
